export const SET_NEW_LOCALE = '[LANGUAGE] Set new locale';



// WEBPACK FOOTER //
// ./src/ui/features/Login/state/languageTypes.js